module.exports = __webpack_public_path__ + "media/images/sp/specials/common/event_detail_try_on-af080374b65029b8eda509841444046a.jpg";